import CallBadge from 'flow/components/ui-components/CallBadge';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectKeysWaitingQueueItems } from 'flow/selectors/queue-selectors';
import { QueueKey } from 'flow/types/EntityKeys';

interface Props {
    queueKey: QueueKey;
    className?: string;
}

const CallsInQueueCount = ({ queueKey, className = 'size-6' }: Props) => {
    const numberOfCallsInQueue = useAppSelector(
        (state) => selectKeysWaitingQueueItems(state, queueKey)?.size || 0,
    );

    if (numberOfCallsInQueue === 0) return null;

    return (
        <div className={className}>
            <CallBadge dataTestId="queue-card-calls-in-queue-count">
                {numberOfCallsInQueue}
            </CallBadge>
        </div>
    );
};

export default CallsInQueueCount;
